export enum Type {
  AUDIOGRAM_WIZARD_CREATE_REQUEST = 'app/audiogram-wizard/AUDIOGRAM_WIZARD_CREATE_REQUEST',
  AUDIOGRAM_WIZARD_CREATE_SUCCESS = 'app/audiogram-wizard/AUDIOGRAM_WIZARD_CREATE_SUCCESS',
  AUDIOGRAM_WIZARD_CREATE_FAILURE = 'app/audiogram-wizard/AUDIOGRAM_WIZARD_CREATE_FAILURE',

  AUDIOGRAM_WIZARD_CLEAR = 'app/audiogram-wizard/AUDIOGRAM_WIZARD_CLEAR',
}
